<template>
  <Day day="16.12.2025">
    <div slot="page-content">
      <h3>🌳 Into the Woods 🌳 </h3>
      <p>
        <img src="@/assets/day16.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day16',
  components: {
    Day
  }
}
</script>
